// ABOUTME: Which kind of GraphQL operation a link is looking at.
// ABOUTME: Shared by the links that treat reads differently from writes.

import type { DocumentNode } from "graphql"
import { Kind, OperationTypeNode } from "graphql"
import { getMainDefinition } from "@apollo/client/utilities"

/**
 * Two links in this chain act on reads only and pass everything else straight through: the
 * concurrency limiter (a mutation must not queue behind a batch of queries) and the timeout (a
 * mutation or a file upload must not be cut off). The check was spelled out in both, which jscpd
 * rightly counted as a clone — it is one concept, so it lives in one place.
 */
export const isQueryOperation = (query: DocumentNode): boolean => {
  const definition = getMainDefinition(query)
  return definition.kind === Kind.OPERATION_DEFINITION && definition.operation === OperationTypeNode.QUERY
}

/**
 * Asked for by name rather than as "not a query": a subscription is neither a read nor a save, and
 * the slow-save notice must not announce one as an unfinished write.
 */
export const isMutationOperation = (query: DocumentNode): boolean => {
  const definition = getMainDefinition(query)
  return definition.kind === Kind.OPERATION_DEFINITION && definition.operation === OperationTypeNode.MUTATION
}
